import { createSlice } from '@reduxjs/toolkit'
import HomeAPIs from "api/Profile/index";
import { requests } from 'api/index';
import URLS  from 'api/endPoints';
import DocApis from "api/Profile/Documents"

const initialProfile = {
  SINGLEAPPLICANTINFO: "",
  RESUMEDATA: "",
  SINGLEUSERJOURNEY:"",
  CURRENTRESUME:"",
  DOCUMENTS:"",
  UPLOADDOCUMENT:"",
  VIEWDOCUMENT:"",
  PARSERESUME:""
}

const slice = createSlice({
    name: "PROFILE",
    initialState: {
        home:initialProfile
    },
  reducers: {
    getSingleApplicantInfo: (state, action) => {
      // console.log("Profile", action.payload)
      state.home.SINGLEAPPLICANTINFO = action.payload
    },
    uploadAppResumeMgReducer: (state, action) => {
      state.home.RESUMEDATA = action.payload
    },
     getUserSingleUserJourneyReducer: (state, action) => {
            // console.log("user joruney", action.payload)
            state.home.SINGLEUSERJOURNEY = action.payload
    },
    getCURRENTRESUMEReducer: (state, action) => {
      // console.log("user joruney", action.payload)
      state.home.CURRENTRESUME = action.payload
},
  uploadDocuments: (state, action) => {
    state.home.UPLOADDOCUMENT = action.payload
  },
  getDocs: (state, action) =>{
    state.home.DOCUMENTS = action.payload
  },
  viewDocument: (state, action) => {
    state.home.VIEWDOCUMENT = action.payload
  },
  getparseResumeReducer: (state, action) => {
    state.home.PARSERESUME = action.payload
  }
  }
})

export default slice.reducer

const {getparseResumeReducer,viewDocument,getDocs,uploadDocuments, getSingleApplicantInfo, uploadAppResumeMgReducer,getUserSingleUserJourneyReducer,getCURRENTRESUMEReducer } = slice.actions
export const ViewDocumentAction = (payload) => async (dispatch) => {
  
  try {
   
    let response = await DocApis.ViewDocument(payload)
   
      await dispatch(viewDocument(response))

      return await returnCode(response)
  } catch (error) {
      return console.error(error.message)
  }
}

export const getDocsAction = (payload) => async (dispatch) => {
  
  try {
   
    let response = await DocApis.GetDocs(payload)
   
      await dispatch(getDocs(response))

      return await returnCode(response)
  } catch (error) {
      return console.error(error.message)
  }
}
export const uploadDocumentsAction = (payload) => async (dispatch) => {
  
  try {
   
    let response = await DocApis.uploadDocs(payload)
    
   
      await dispatch(uploadDocuments(response))
      // console.log(returnCode(response))
      return await returnCode(response)
  } catch (error) {
      return console.error(error.message)
  }
}
export const getSingleApplicantInfoAction = (payload) => async (dispatch) => {
  
    try {
     
      let response = await requests.get(URLS.magUrl.getApplicantProfile + payload.HcId +'/'+ payload.MgId)
      
     if(response.ResponseCode==100){


        await dispatch(getSingleApplicantInfo(response))
      }
        return await returnCode(response)
    } catch (error) {
        return console.error(error.message)
    }
}

export const uploadAppResumeMgAction = (payload) => async (dispatch) => {
  try {
    let response = await HomeAPIs.uploadAppResumeMg(payload)
    await dispatch(uploadAppResumeMgReducer(response))

    return await returnCode(response)
  } catch (error) {
    return console.error(error.message)
  }
}


export const getUserSingleUserJourneyAction = (payload) => async (dispatch) => {
    try {
     
      let response = await requests.get(URLS.magUrl.getUserSingleuserJourney +'/'+ payload.HcId  )
      
     
        await dispatch(getUserSingleUserJourneyReducer(response))

        return await returnCode(response)
    } catch (error) {
        return console.error(error.message)
    }
}

export const geResumeHC = (payload) => async (dispatch) => {
  try {
   
  
    let response = await HomeAPIs.geResumeHC(payload)
    if(response.ResponseCode==100){
      await dispatch(getCURRENTRESUMEReducer(response));
    }
      return await returnCode(response)
  } catch (error) {
      return console.error(error.message)
  }
}
export const parseResume = (payload) => async (dispatch) => {
  try {
   
  
    let response = await HomeAPIs.parseResume(payload)
    if(response.ResponseCode==100){
      await dispatch(getparseResumeReducer(response));
    }
      return await returnCode(response)
  } catch (error) {
      return console.error(error.message)
  }
}

export const uploadResume = (payload) => async (dispatch) => {
  try {
   
  
    let response = await HomeAPIs.uploadResume(payload)
   
   //   await dispatch(getCURRENTRESUMEReducer(response))

      return await returnCode(response)
  } catch (error) {
      return console.error(error.message)
  }
}

export const upploadDocument = (payload) => async (dispatch) => {
  try {
   
  
    let response = await HomeAPIs.upploadDocument(payload)
   
   //   await dispatch(getCURRENTRESUMEReducer(response))

      return await returnCode(response)
  } catch (error) {
      return console.error(error.message)
  }
}
export const upploadProfilePhotoMG = (payload) => async (dispatch) => {
  try {
   
  
    let response = await HomeAPIs.updateUserProfile(payload)
   
   //   await dispatch(getCURRENTRESUMEReducer(response))

      return await returnCode(response)
  } catch (error) {
      return console.error(error.message)
  }
}
export const getApplicantHistory = (payload) => async (dispatch) => {
  try {
   
  
    let response = await HomeAPIs.getApplicantHistory(payload)
   
   //   await dispatch(getCURRENTRESUMEReducer(response))

      return await returnCode(response)
  } catch (error) {
      return console.error(error.message)
  }
}
export const setCurrentResumeAction = (payload) => async (dispatch) => {

  try {

    await dispatch(getCURRENTRESUMEReducer(payload))

      return await returnCode(payload)
  } catch (error) {
      return console.error(error.message)
  }
}



function returnCode(response) {
  if (response.ResponseCode == 100 || 200) {
    return response;
  } else if (response.ResponseCode == 103) {
    return 103;
  } else {
    return 101;
  }
}
